module.exports = __webpack_public_path__ + "static/media/ppp.45f7ceb6.svg";